import React from "react";
import { StyleSheet } from "react-native";

import { Box } from "../../../../../../mads";
import {
  useIsDesktopDisplay,
  useViewjobOneGraphModel,
} from "../../../../context/ViewJobDataContext";
import { CompanyNameSection } from "../CompanyNameSection";
import { CompanyRatingSection } from "./CompanyRatingSection";

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "flex-end",
    columnGap: 0,
  },
  desktopContainer: {
    marginBottom: 4,
  },
});

export function CompanySection() {
  const viewjobOneGraphModel = useViewjobOneGraphModel();
  const { companyReviewLink, ratings, hideRating } = viewjobOneGraphModel?.employer ?? {};

  const showRatings = !hideRating && !!ratings && ratings.count > 0 && !!companyReviewLink;
  const isDesktop = useIsDesktopDisplay();

  return (
    <Box sx={[styles.container, isDesktop && styles.desktopContainer]}>
      <CompanyNameSection showRatings={showRatings} />

      {showRatings && <CompanyRatingSection />}
    </Box>
  );
}
